import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AFFILIATE_ROUTES, ProtectedRoute, UserRole } from '@dukene/shared';

// Layouts
import DashboardLayout from './components/layout/DashboardLayout';
import AuthLayout from './components/layout/AuthLayout';

// Auth Pages
import Login from './pages/auth/Login';
import VerifyEmail from './pages/auth/VerifyEmail';
import Apply from './pages/Apply';

// Dashboard Pages
import Dashboard from './pages/Dashboard';
import Links from './pages/Links';
import Commissions from './pages/Commissions';
import Analytics from './pages/Analytics';
import Payouts from './pages/Payouts';
import Profile from './pages/Profile';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
        </Route>

        {/* Dashboard Routes - Protected */}
        <Route element={<ProtectedRoute allowedRoles={[UserRole.AFFILIATE]}><DashboardLayout /></ProtectedRoute>}>
          <Route path={AFFILIATE_ROUTES.DASHBOARD} element={<Dashboard />} />
          <Route path={AFFILIATE_ROUTES.LINKS} element={<Links />} />
          <Route path={AFFILIATE_ROUTES.COMMISSIONS} element={<Commissions />} />
          <Route path={AFFILIATE_ROUTES.ANALYTICS} element={<Analytics />} />
          <Route path={AFFILIATE_ROUTES.PAYOUTS} element={<Payouts />} />
          <Route path={AFFILIATE_ROUTES.PROFILE} element={<Profile />} />
        </Route>

        {/* Redirect root to dashboard */}
        <Route path="*" element={<Navigate to={AFFILIATE_ROUTES.DASHBOARD} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
